import Vue from "vue";
import Vuebar from "vuebar";
import { config } from "@/constants";

const isDev = process.env.NODE_ENV !== "production";

if (!isDev) {
  import(/* webpackChunkName: "bootstrapVue" */ "@/components/bootstrap");
} else {
  require("@/components/bootstrap");
}

import store from "./store/index";
import router from "./router/index";
import variables from "./styles/general/_variables.scss";

import TranslatorPlugin from "./plugins/translator";
import AuthPlugin from "./plugins/auth";
import DatePlugin from "./plugins/date";
import MoneyPlugin from "./plugins/money";
import WebsitePathPlugin from "./plugins/websitePath";
import BreakpointPlugin from "./plugins/breakpoint";
import NumberPlugin from "./plugins/number";
import FlashPlugin from "./plugins/flash";
import TourPlugin from "./plugins/tour";
import ClipboardPlugin from "./plugins/clipboard";
import Vue2TouchEvents from "vue2-touch-events";
import VueYouTubeEmbed from "vue-youtube-embed";
import VueGtm from "vue-gtm";
import RedirectPlugin from "./plugins/redirect";

Vue.use(VueYouTubeEmbed, { global: false });
Vue.use(Vue2TouchEvents, {
  swipeTolerance: 50,
});
Vue.use(BreakpointPlugin, {
  xs: parseInt(variables.gridBreakpointsXs),
  sm: parseInt(variables.gridBreakpointsSm),
  md: parseInt(variables.gridBreakpointsMd),
  lg: parseInt(variables.gridBreakpointsLg),
  xl: parseInt(variables.gridBreakpointsXl),
});
Vue.use(TranslatorPlugin, {
  lang: () => {
    return store.getters.lang;
  },
});
Vue.use(NumberPlugin, {
  locale: () => {
    return store.getters.locale;
  },
});
Vue.use(AuthPlugin);
Vue.use(WebsitePathPlugin);
Vue.use(MoneyPlugin);
Vue.use(DatePlugin, {
  lang: () => {
    return store.getters.lang;
  },
});
Vue.use(FlashPlugin);
Vue.use(Vuebar);
Vue.use(TourPlugin);
Vue.use(ClipboardPlugin);
Vue.use(RedirectPlugin);

if (config.gtmId) {
  Vue.use(VueGtm, {
    id: config.gtmId,
    enabled: true,
    debug: !!config.gtmDebug,
    loadScript: true,
    vueRouter: router,
  });
}
